<template>
    <section class="section discover-area bg-gray overflow-hidden ptb_100">
            <div class="container">
                <div class="row justify-content-between align-items-center">
                    <div class="col-12 col-lg-6 order-2 order-lg-1">
                        <!-- Discover Thumb -->
                        <div class="service-thumb discover-thumb mx-auto text-center">
                            <img :src="data.image" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 order-1 order-lg-2">
                        <!-- Discover Text -->
                        <div class="discover-text px-0 px-lg-4 pt-4 pt-lg-0">
                            <h2 class="pb-4">{{data.title}}</h2>
                            <p v-if="data.subtitle">{{data.subtitle}}<br/><br/></p>
                            <!-- Check List -->
                            <ul class="check-list">
                                <li v-for="(feature, index) in data.features" :key="index" class="py-1">
                                    <!-- List Box -->
                                    <div class="list-box media">
                                        <span class="icon align-self-center"><i class="fas fa-check"></i></span>
                                        <span class="media-body pl-2">{{feature}}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    props: ['data']
}
</script>
